/** Clone the fixed onboarding sample through the authenticated backend. */
import { getAuthHeaders } from './apiUtils';
import { ServerURI } from '../globals';

export const cloneInitialData = async () => {
  const response = await fetch(`${ServerURI}/api/v3/patients/clone-sample`, {
    method: 'POST',
    headers: await getAuthHeaders(),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || `Sample patient cloning failed (${response.status})`);
  }
  return response.json();
};
